module.exports = __webpack_public_path__ + "img/vehicle.6b37669e.svg";